import { rfqConfirmationHeaderStyles as styles } from "@bevco/Overrides/Widgets/RfqConfirmation/RfqConfirmationHeader";
import { css } from "styled-components";

styles.continueButton = {
    ...styles.continueButton,
    css: css`
        ${styles.continueButton?.css}
        span {
            pointer-events: none;
        }
    `,
};
